/**
 * App — root application component (Pattern 8.1 / NFR-RESIL-FE-01).
 *
 * Routes:
 *   /           → DashboardPage (wrapped in ErrorBoundary)
 *   /accounts   → AccountSettingsPage (wrapped in ErrorBoundary)
 *   *           → redirect to /
 *
 * Each page is wrapped in its own ErrorBoundary so a render error in one page
 * does not crash the other (Pattern 8.1).
 *
 * AppLayout provides the persistent navigation shell, skip link, and alert badge.
 */
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AppLayout } from '@/components/AppLayout';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { DashboardPage } from '@/pages/DashboardPage';
import { AccountSettingsPage } from '@/pages/AccountSettingsPage';

export default function App() {
  return (
    <BrowserRouter>
      <AppLayout>
        <Routes>
          <Route
            path="/"
            element={
              <ErrorBoundary pageName="Dashboard">
                <DashboardPage />
              </ErrorBoundary>
            }
          />
          <Route
            path="/accounts"
            element={
              <ErrorBoundary pageName="Account Settings">
                <AccountSettingsPage />
              </ErrorBoundary>
            }
          />
          {/* Catch-all — redirect unknown paths to dashboard */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AppLayout>
    </BrowserRouter>
  );
}
